var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M184.529 316.876C184.653 303.155 189.681 291.322 199.611 281.376C208.725 272.152 222.591 263.869 241.209 256.526C247.419 254.159 259.898 249.361 278.646 242.131C292.651 236.77 299.651 231.472 299.645 226.236C299.645 219.621 294.618 214.757 284.564 211.645C276.875 209.148 267.365 207.903 256.033 207.909C237.941 207.909 224.965 210.678 217.105 216.216C209.245 221.754 205.321 230.564 205.333 242.646H187.696C187.696 223.458 195.225 210.119 210.283 202.628C221.639 196.895 236.362 194.028 254.454 194.028C269.642 194.028 282.452 195.774 292.885 199.265C308.854 204.761 316.838 213.932 316.838 226.777C316.838 238.255 301.585 249.598 271.079 260.804C262.627 263.928 251.931 268.043 238.991 273.149C231.71 276.565 224.861 280.834 218.587 285.867C210.804 292.073 205.924 297.783 203.949 302.996H316.918V316.841L184.529 316.876Z",
    fill: "#E7286B",
    stroke: "#E7286B",
    strokeWidth: 2.66
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.96 2C129.127 2 146.048 8.64442 158.722 21.9333C171.397 35.2221 177.731 53.046 177.725 75.4051C177.725 97.6991 171.391 115.491 158.722 128.779C146.054 142.068 129.133 148.716 107.96 148.721C86.7278 148.721 69.7597 142.089 57.0558 128.824C44.3519 115.559 38 97.7524 38 75.4051C38 53.052 44.3519 35.228 57.0558 21.9333C69.7597 8.6385 86.7278 1.99409 107.96 2ZM107.96 17.5313C93.1389 17.5313 81.3606 22.7083 72.6252 33.0625C63.8898 43.4167 59.528 57.5309 59.5398 75.4051C59.5398 93.2143 63.9016 107.296 72.6252 117.65C81.3488 128.004 93.1271 133.184 107.96 133.19C122.793 133.19 134.539 128.01 143.197 117.65C151.856 107.29 156.188 93.2084 156.194 75.4051C156.194 57.5427 151.862 43.4285 143.197 33.0625C134.533 22.6965 122.787 17.5194 107.96 17.5313Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.7,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M209.671 4.55615H237.172L304.107 122.833V4.55615H323.926V145.97H296.425L229.454 27.6667V145.97H209.671V4.55615Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.7,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M364.566 4.55615H460.005V20.6554H384.988V62.5277H456.847V78.6269H384.988V129.871H461.833V145.97H364.566V4.55615Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.7,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.0558 477.957C44.3519 464.662 38 446.838 38 424.485C38 402.132 44.3519 384.326 57.0558 371.067C69.7597 357.796 86.7308 351.163 107.969 351.169C129.207 351.175 146.125 357.822 158.722 371.111C171.391 384.406 177.725 402.197 177.725 424.485C177.725 446.773 171.391 464.597 158.722 477.957C146.042 491.246 129.124 497.89 107.969 497.89C86.8136 497.89 69.8425 491.246 57.0558 477.957ZM143.197 466.828C151.856 456.468 156.188 442.354 156.194 424.485C156.2 406.617 151.868 392.535 143.197 382.24C134.539 371.88 122.796 366.703 107.969 366.709C93.1418 366.715 81.3635 371.892 72.6341 382.24C63.9046 392.594 59.5398 406.676 59.5398 424.485C59.5398 442.294 63.9046 456.409 72.6341 466.828C81.3576 477.182 93.1359 482.359 107.969 482.359C122.802 482.359 134.545 477.182 143.197 466.828V466.828Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.7,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M209.68 353.92H229.454V472.224L296.389 353.92H323.891V495.335H304.107V377.031L237.172 495.335H209.671L209.68 353.92Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.7,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M364.566 353.92H461.833V370.02H384.988V421.264H456.847V437.363H384.988V479.235H460.005V495.335H364.566V353.92Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2.7,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.8640ae39ba555af998f49437b6652813.svg";
export { ForwardRef as ReactComponent };